'use client';

import classNames from 'classnames';
import Link from 'next/link';
import { useState } from 'react';

import { HeaderNavItem } from '~components/Headers/HeaderCommon/HeaderNavItem/HeaderNavItem';
import { HeaderNavToggle } from '~components/Headers/HeaderCommon/HeaderNavToggle/HeaderNavToggle';
import { Image } from '~components/Image/Image';
import { LayoutContainer } from '~components/LayoutContainer/LayoutContainer';
import { LayoutContainerMods } from '~components/LayoutContainer/LayoutContainer.types';
import { useBreakpoints } from '~hooks/useBreakpoints';
import { useScrollLock } from '~hooks/useScrollLock';
import { ThemesNames } from '~types/Theme.types';
import { URLS } from '~types/Urls.types';

import styles from './HeaderHrTek.module.scss';
import { HeaderHrTekProps } from './HeaderHrTek.types';
import { HeaderHrTekUser } from './HeaderHrTekUser/HeaderHrTekUser';

export const HeaderHrTek = ({
  mod = ThemesNames.White,
  className,
  headerRef,
  catalog,
}: HeaderHrTekProps) => {
  const [, { isDesktop }] = useBreakpoints();
  const [isOpen, setIsOpen] = useState(false);

  const handleHeaderToggle = () => {
    setIsOpen((prev) => !prev);
  };

  useScrollLock(isOpen);

  const { items, logo } = catalog || {};

  function MainLogo() {
    return (
      <Link href={logo?.href || URLS.OriginHrtek} className={styles.logoLink}>
        <Image
          className={styles.logoImg}
          src={(isDesktop ? logo?.logo?.src : logo?.logoMobile?.src) || ''}
          alt="HrTek"
        />
      </Link>
    );
  }

  return (
    <>
      <header
        className={classNames(styles.header, className, {
          [styles[mod]]: mod,
        })}
        ref={headerRef}
        data-testid="header"
      >
        <LayoutContainer mods={[LayoutContainerMods.Inner]}>
          <div className={styles.container}>
            <div className={styles.logoWrapper}>
              {!isDesktop && (
                <div onClick={handleHeaderToggle}>
                  <HeaderNavToggle
                    className={styles.headerNavToggle}
                    isActive={isOpen}
                  />
                </div>
              )}
              <MainLogo />
              {isDesktop &&
                items?.map((item) => (
                  <div key={item.id} className={styles.navItem}>
                    <HeaderNavItem {...item} />
                  </div>
                ))}
            </div>
            <div className={styles.buttons}>
              <HeaderHrTekUser mod={mod} />
            </div>
          </div>
        </LayoutContainer>
      </header>
      {!isDesktop && (
        <div
          className={classNames(styles.menuContainer, {
            [styles.open]: isOpen,
          })}
        >
          <nav className={styles.nav}>
            {items?.map((item) => (
              <div key={item.id} className={styles.navItem}>
                <HeaderNavItem {...item} />
              </div>
            ))}
          </nav>
        </div>
      )}
    </>
  );
};
